// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import Login from './components/Auth/Login';
import GlobePageIntegrated from './components/Globe/GlobePageIntegrated';
import SensorPage from './components/SensorPage/SensorPage';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import './App.css';

function App() {
  return (
    <WalletProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Rota de login */}
            <Route path="/login" element={<Login />} />
            
            {/* Rotas protegidas */}
            <Route 
              path="/globe" 
              element={
                <ProtectedRoute>
                  <GlobePageIntegrated />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/sensor/:id" 
              element={
                <ProtectedRoute>
                  <SensorPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Redirecionar raiz para login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </WalletProvider>
  );
}

export default App;